// App Imports
import { API_URL, IMAGE_SOURCE_PATH } from '../../../setup/config/env'
import params from '../../../setup/config/params'
import CreateOrUpdate from '../CreateOrUpdate'
import BulkCreate from '../BulkCreate'
import List from '../List'
import Manage from '../Manage'
import { defaultImage } from '../../common/Sidebar';
// Image
export function imageCategory(image = defaultImage) {
  return `${ API_URL }/${ params.category.image.path }/${ image }`
}

export function getImageSource(image = defaultImage, updatedAt) {
  const targetImage = image || defaultImage || "default.jpg";
  if (typeof targetImage === 'string' && (targetImage.startsWith('http://') || targetImage.startsWith('https://') || targetImage.startsWith('data:') || targetImage.startsWith('blob:'))) {
    return targetImage;
  }
  const cleanImage = typeof targetImage === 'string' ? targetImage.replace(/^\/+/, '') : targetImage;
  const basePath = IMAGE_SOURCE_PATH ? (IMAGE_SOURCE_PATH.endsWith('/') ? IMAGE_SOURCE_PATH : `${IMAGE_SOURCE_PATH}/`) : '/';
  const cacheQuery = updatedAt ? `?t=${new Date(updatedAt).getTime()}` : '';
  return `${basePath}${cleanImage}${cacheQuery}`;
}

// Pages routes
const routes = {
  categoryList: {
    path: '/category',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "category",
    action:"canView"
  },

  categoryCreate: {
    path: '/category/create',
    component: CreateOrUpdate,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "category",
    action:"canCreate"
  },

  categoryBulkCreate: {
    path: '/category/bulkcreate',
    component: BulkCreate,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "category",
    action:"canCreate"
  },

  categoryEdit: {
    path: (categoryId = ':categoryId') => (`/category/edit/${ categoryId }`),
    component: CreateOrUpdate,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "category",
    action:"canEdit"
  },

  categoryManage: {
    path: (categoryId = ':categoryId') => (`/category/manage/${ categoryId }`),
    component: Manage,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "category",
    action:"canView"
  }
}
export default routes;